import React, { useEffect, useRef , useState } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import "./homepage.css";
import KeyboardArrowRightRoundedIcon from '@mui/icons-material/KeyboardArrowRightRounded';
import CourseCard from "../../components/courseCard/courseCard";
import TestimonialsGrid from "../../components/testimonials/testimonials";
import BookDemoForm from "../demo/bookDemo";
import { getContent } from "../../api/content";
import { getCourseData } from "../../api/course";
import Carousel from 'react-bootstrap/Carousel';

const Homepage = (props) => {
    const navigate = useNavigate();
    const toastRef = useRef(null);
    const [loadingData, setLoadingData] = useState(true)
    const [content, setContent] = useState([])
    const [courses, setCourses] = useState([])
    const [socialStat, setSocialStats] = useState([])
    const location = useLocation();
    const scrollRef = useRef(null);
    const [index, setIndex] = useState(0);

  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };

    useEffect(() => {
        const fetchData = async () => {
          try {
            const [contentData, courseData, statsData] = await Promise.all([
              getContent('home_page_content'),
              getCourseData('home'),
              getContent('home_social_stats'),
            ]);
      
            if (contentData.status && courseData.status && statsData.status) {
              setContent(contentData.data[0]['content']);
              setCourses(courseData.data);
              setSocialStats(statsData.data[0]['stats']);
              setLoadingData(false);
            } else {
              console.log("Error: One or both fetch requests failed.");
            }
          } catch (error) {
            console.log("Error fetching data:", error);
          }
        };
      
        fetchData();
      }, []);

      const handleClick = (destination) => {
        navigate("/" + destination);
    }

    return (
        loadingData == true ? (
            <div class="d-flex justify-content-center">
              <div class="spinner-border" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : (
                <>
                    <div>
                        <Carousel className="carousel-main" activeIndex={index} onSelect={handleSelect}>
                            <Carousel.Item>
                            <div className="detail-top-container">
                                <div className="row">
                                    <div className="col-6 text-left d-flex flex-column justify-content-center">
                                        <span className="head-text text-grey h1 m-10">
                                            {content['top_banner']['title']}
                                        </span>
                                        <span className="text-secondary-main text-lighter h2 m-10">
                                            {content['top_banner']['subhead']}
                                        </span>
                                        <br/>
                                        <div className="head-description text-darkGrey h6">
                                            {content['top_banner']['subText']}
                                        </div>
                                        <div className="container-button">
                                            <button class="primary-button btn btn-primary btn-lg custom-shadow top-banner-button" onClick={() => handleClick("all-courses")}>{content['top_banner']['button']} <KeyboardArrowRightRoundedIcon/></button>
                                        </div>
                                    </div>
                                    <div className="col-6">
                                        <img className= "top-banner-image" src="/images/home_banner_1.png"/>
                                    </div>
                                </div>
                            </div>
                            </Carousel.Item>
                            <Carousel.Item>
                                <div className="container banner_img_container">
                                    <img src="/images/banners/website.jpg" className="full-width-img"/>
                                </div>
                            </Carousel.Item>
                        </Carousel>
                        <div className="middle-container container">
                            <div className="row">
                                <span className="head-text h1 text-center text-grey">
                                    Why Learn with Us
                                </span>
                            </div>
                            
                            <div className="scroll-wrapper mt-5">
                                <div className="scroll-track">
                                    {/* Scroll content duplicated twice */}
                                    {[...Array(2)].map((_, i) => (
                                    <div className="scroll-content" key={i}>
                                        <div className="card color-primary text-white custom-shadow mx-4" style={{ width: "22rem" }}>
                                        <div className="row g-0 card-row">
                                            <div className="col-md-4 d-flex justify-content-center">
                                            <img className="card-icon" src="/images/card_icon1.png" />
                                            </div>
                                            <div className="col-md-8">
                                            <div className="card-body">
                                                <h5 className="card-title h5">Strategy Over Guesswork</h5>
                                                <p className="card-text">We don’t leave success to chance—your child learns with a clear, proven roadmap.</p>
                                            </div>
                                            </div>
                                        </div>
                                        </div>

                                        <div className="card color-primary text-white custom-shadow mx-4" style={{ width: "22rem" }}>
                                        <div className="row g-0 card-row">
                                            <div className="col-md-4 d-flex justify-content-center">
                                            <img className="card-icon" src="/images/card_icon1.png" />
                                            </div>
                                            <div className="col-md-8">
                                            <div className="card-body">
                                                <h5 className="card-title h5">Trio Model for Success</h5>
                                                <p className="card-text">A blend of Expert Faculty, Personalized Mentorship & Daily Improvement.</p>
                                            </div>
                                            </div>
                                        </div>
                                        </div>

                                        <div className="card color-primary text-white custom-shadow mx-4" style={{ width: "22rem" }}>
                                        <div className="row g-0 card-row">
                                            <div className="col-md-4 d-flex justify-content-center">
                                            <img className="card-icon" src="/images/card_icon1.png" />
                                            </div>
                                            <div className="col-md-8">
                                            <div className="card-body">
                                                <h5 className="card-title h5">Expert-Led Courses</h5>
                                                <p className="card-text">Learn from top educators with years of experience in JEE, NEET & Board exams.</p>
                                            </div>
                                            </div>
                                        </div>
                                        </div>

                                        <div className="card color-primary text-white custom-shadow mx-4" style={{ width: "22rem" }}>
                                        <div className="row g-0 card-row">
                                            <div className="col-md-4 d-flex justify-content-center">
                                            <img className="card-icon" src="/images/card_icon1.png" />
                                            </div>
                                            <div className="col-md-8">
                                            <div className="card-body">
                                                <h5 className="card-title h5">Real-Time Progress Tracking</h5>
                                                <p className="card-text">Stay on top with analytics, feedback, and daily improvements.</p>
                                            </div>
                                            </div>
                                        </div>
                                        </div>

                                        <div className="card color-primary text-white custom-shadow mx-4" style={{ width: "22rem" }}>
                                        <div className="row g-0 card-row">
                                            <div className="col-md-4 d-flex justify-content-center">
                                            <img className="card-icon" src="/images/card_icon2.png" />
                                            </div>
                                            <div className="col-md-8">
                                            <div className="card-body">
                                                <h5 className="card-title h5">Interactive Learning</h5>
                                                <p className="card-text">Engage with AI-powered quizzes, live doubt sessions & interactive lessons.</p>
                                            </div>
                                            </div>
                                        </div>
                                        </div>

                                        <div className="card color-primary text-white custom-shadow mx-4" style={{ width: "22rem" }}>
                                        <div className="row g-0 card-row">
                                            <div className="col-md-4 d-flex justify-content-center">
                                            <img className="card-icon" src="/images/card_icon3.png" />
                                            </div>
                                            <div className="col-md-8">
                                            <div className="card-body">
                                                <h5 className="card-title h5">Personalised Study Plans</h5>
                                                <p className="card-text">Tailor your learning journey with AI-driven progress tracking.</p>
                                            </div>
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                        <div className="course-container-home container my-5">
                            <div className="row mb-5">
                                <span className="text-center text-grey h1 text-bold">Find the Right </span><br/>
                                <span className="text-center text-secondary-main h2">Course For You</span>
                            </div>
                            <div className="row row-cols-1 row-cols-md-3 gy-5">
                                <CourseCard data={courses} />
                            </div>
                            {/* <div className="row mt-5">
                                <div className="col text-center">
                                    <button className="primary-button btn btn-primary custom-shadow" type="button">
                                        Explore All Courses <KeyboardArrowRightRoundedIcon />
                                    </button>
                                </div>
                            </div> */}
                        </div>
                    </div>
                    <div className="container-large d-flex flex-column justify-content-center align-items-center text-center my-5 custom-shadow">
                        <div className="row mb-4">
                            <div className="col">
                            <span className="head-text h1 text-white">
                                Our Achievements
                            </span>
                            </div>
                        </div>
                        <div className="container mt-2">
                            <div className="row">
                                <div className="col ac-card achieve-card-r">
                                    <div className="achievement-card rounded-4 d-flex align-items-center">
                                        <div className="icon-container flex-grow-0" style={{ flexBasis: '40%' }}>
                                            <img src="/images/studentIcon.png" alt="Icon" width="100%" className="img-fluid" />
                                        </div>
                                        <div style={{ flexBasis: '60%' }}>
                                            <h3 className="fw-bold mb-1">{socialStat['students']}</h3>
                                            <p className="mb-0">Live<br />Students</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col ac-card achieve-card-c1">
                                    <div className="achievement-card rounded-4 d-flex align-items-center">
                                        <div className="icon-container flex-grow-0" style={{ flexBasis: '40%' }}>
                                            <img src="/images/liveClass.png" alt="Icon" width="100%" className="img-fluid" />
                                        </div>
                                        <div style={{ flexBasis: '60%' }}>
                                            <h3 className="fw-bold mb-1">{socialStat['teachers']}</h3>
                                            <p className="mb-0">Certified<br />Teachers</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col ac-card achieve-card-c2">
                                    <div className="achievement-card rounded-4 d-flex align-items-center">
                                        <div className="icon-container flex-grow-0" style={{ flexBasis: '40%' }}>
                                            <img src="/images/group.png" alt="Icon" width="100%" className="img-fluid" />
                                        </div>
                                        <div style={{ flexBasis: '60%' }}>
                                            <h3 className="fw-bold mb-1">{socialStat['followers']}</h3>
                                            <p className="mb-0">Our<br />Followers</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col ac-card achieve-card-l">
                                    <div className="achievement-card rounded-4 d-flex align-items-center">
                                        <div className="icon-container flex-grow-0" style={{ flexBasis: '40%' }}>
                                            <img src="/images/video.png" alt="Icon" width="100%" className="img-fluid" />
                                        </div>
                                        <div style={{ flexBasis: '60%' }}>
                                            <h3 className="fw-bold mb-1">{socialStat['classes']}</h3>
                                            <p className="mb-0">Classes<br />Complete</p>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div className="container testimonial-container d-flex flex-column align-items-center my-5">
                        <div className="row mb-5">
                            <span className="text-center text-grey h1 text-bold">What Our</span><br/>
                            <span className="text-center text-secondary-main h2">Students Say</span>
                        </div>
                        <div className="row row-cols-1 row-cols-md-3 g-5">
                            <TestimonialsGrid />
                        </div>
                    </div>
                    <div className="demo-container" id="demo">
                        <div className="container d-flex flex-column mt-5">
                            <div className="row">
                                <BookDemoForm/>
                            </div>
                        </div>
                    </div>
                    <div className="position-fixed top-0 end-0 p-3" style={{ zIndex: 11 }}>
                            <div
                                ref={toastRef}
                                className="toast align-items-center text-bg-primary border-0"
                                role="alert"
                                aria-live="assertive"
                                aria-atomic="true">
                                <div className="d-flex">
                                <div className="toast-body">
                                    Payment successful!
                                </div>
                                <button
                                    type="button"
                                    className="btn-close btn-close-white me-2 m-auto"
                                    data-bs-dismiss="toast"
                                    aria-label="Close"
                                ></button>
                                </div>
                            </div>
                        </div>
                </>
          )
    )
}

export default Homepage;